module.exports = __webpack_public_path__ + "img/MCM-TR-white.2a29926a.png";